import * as React from "react";
const SvgView2D20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M2.843 8.518C2.83 8.344 2.8 8.17 2.8 8.011c0-1.102.594-1.987 1.87-1.987 1.218 0 1.813.812 1.813 1.697 0 .768-.42 1.45-1.349 2.03l-1.696 1.088C1.668 11.954 1.03 13.274 1.002 15h7.293v-1.566H3.148c.145-.566.594-.957 1.131-1.29l2.015-1.277c1.19-.739 1.943-1.827 1.943-3.175 0-1.726-1.305-3.19-3.523-3.19-2.291 0-3.61 1.58-3.61 3.35 0 .173.014.362.043.507l1.696.16Zm9.217 4.887v-7.09h1.842c1.784 0 3.248 1.16 3.248 3.566 0 2.378-1.479 3.524-3.262 3.524H12.06ZM13.945 15c2.785 0 5.017-1.827 5.017-5.119 0-3.306-2.203-5.162-5.002-5.162h-3.64V15h3.625Z"
    })
  );
export default SvgView2D20Px;
